class PaginateLoadMore extends HTMLElement {
    constructor() {
        super();
        
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }

        let params = new URLSearchParams(window.location.search);

        this.collectionList = document.getElementById('product-grid');

        this.loadMoreButton = this.querySelector(".load-more-btn");
        this.loadMoreButton.addEventListener('click', this.onButtonClick.bind(this));

        this.previousBox = document.querySelector(".previous-page-box");
        this.previousButton = document.querySelector(".load-previous-btn");

        if (this.previousButton) {
            this.previousButton.addEventListener('click', this.onPreviousButtonClick.bind(this));
        }

        this.progressWrapper = this.querySelector(".load_more_progress");
        this.totalProducts = parseInt(this.progressWrapper.dataset.totalProducts);
        this.initialProducts = document.querySelectorAll('#product-grid > li').length;

        if (params.get('page') && params.get('page') != 1) {
            this.initialProducts = this.initialProducts * parseInt(params.get('page'));
        }

        this.progressWrapper.querySelector('.products_showing').innerHTML = this.initialProducts;
        this.progressWrapper.querySelector('.load_more_progress_bar > div').style.width = (this.initialProducts / this.totalProducts) * 100 + '%';
        
        window.onbeforeunload = function () {
            params = new URLSearchParams(window.location.search);
            localStorage.setItem('collectionsSrollPosition', window.scrollY);
            localStorage.setItem('collectionsLoadedPage', params.get('page'));
            localStorage.setItem('collectionsLoadedUrl', window.location.pathname);
        }

        if (this.previousBox) {
            for (const input of document.querySelectorAll('.facet-checkbox input')) {
                input.addEventListener('change', e => {
                    document.querySelector('.previous-page-box').classList.add('visibly-hidden');   
                });
            }
        }

        console.log('this.loadMoreButton.dataset.currentPage', this.loadMoreButton.dataset.currentPage)
        console.log('this.querySelector(".load-more-btn").dataset.currentPage', this.querySelector(".load-more-btn").dataset.currentPage)

        if (this.previousBox && this.loadMoreButton.dataset.currentPage != 1) {
            document.querySelector('.previous-page-box').classList.remove('visibly-hidden');   
        }
    }

    async loadPage(page, previous) {
        let currentPage = page;
        let totalPages = parseInt(this.loadMoreButton.dataset.totalPages);
        let paginationItemCount = parseInt(this.loadMoreButton.dataset.itemCount);
        const collectionItemCount = parseInt(this.loadMoreButton.dataset.collectionCount);
        this.loadMoreButton.setAttribute("disabled", true);
        this.loadMoreButton.querySelector(".loading-overlay__spinner").classList.remove("hidden");
        this.loadMoreButton.querySelector("[load-more-text]").classList.add('hidden');

        if (previous) {
            this.previousButton.setAttribute("disabled", true);
            this.previousButton.querySelector(".loading-overlay__spinner").classList.remove("hidden");
        }

        //check for query string in url
        let search = "";
        if (window.location.search != "") {
            search = window.location.search.replace("?", "");
        }

        // Update the attributes needed for the next click event
        let next_url = window.location.pathname + "?page=" + currentPage;
        if (search != "") {
            next_url = next_url + "&" + search;
        }

        this.dataset.nextUrl == next_url;
        // /search?options%5Bprefix%5D=last&page=2&q=nail
        var self = this;
        return fetch(next_url).then(function (response) {
            // The API call was successful!
            return response.text();
        }).then(function (html) {

            // Convert the HTML string into a document object
            let parser = new DOMParser();
            let doc = parser.parseFromString(html, 'text/html');

            let responseCollectionList = doc.querySelector('#product-grid').innerHTML;

            if (previous) {
                self.previousButton.removeAttribute("disabled");
                self.previousButton.querySelector(".loading-overlay__spinner").classList.add("hidden");
                self.collectionList.innerHTML = responseCollectionList + self.collectionList.innerHTML;
            } else {
                self.collectionList.innerHTML += responseCollectionList;
            }

            if (currentPage < totalPages) {
                self.loadMoreButton.removeAttribute("disabled");
                self.loadMoreButton.querySelector(".loading-overlay__spinner").classList.add("hidden");
                self.loadMoreButton.querySelector("[load-more-text]").classList.remove('hidden');
                // counter.innerText = document.querySelector('#product-grid').getAttribute("data-item-total") * currentPage || paginationItemCount * currentPage;
                self.collectionList.setAttribute("data-item-count", paginationItemCount * currentPage)
            } else {
                self.querySelector('.load-more_wrap').classList.add("hidden");
                // counter.innerText = collectionItemCount;
            }

            if (self.previousBox) {
                if (parseInt(document.querySelector('.load-previous-btn').dataset.currentPage) == 1) {
                    self.previousBox.classList.add('visibly-hidden');
                }
        
                if (parseInt(document.querySelector('.load-previous-btn').dataset.currentPage) > 1) {
                    self.previousBox.classList.remove('visibly-hidden');
                }
            }
        }).catch(function (err) {
            // There was an error
            console.warn('Something went wrong.', err);
        }).then(e => {
            loadReviewsIoRatingSnippets();

            if (!previous) {
                if (this.loadMoreButton.dataset.currentPage == this.loadMoreButton.dataset.totalPages) {
                    this.progressWrapper.querySelector('.products_showing').innerHTML = this.totalProducts;
                    this.progressWrapper.querySelector('.load_more_progress_bar > div').style.width = '100%';
                } else {
                    // let loadedCount = this.querySelector('.load-more-btn').dataset.itemCount * this.querySelector('.load-more-btn').dataset.currentPage;
    
                    // if (!document.querySelector('.previous-page-box').classList.contains('visibly-hidden')) {
                    //     loadedCount = document.querySelectorAll('#product-grid > li').length;
                    // }
    
                    let loadedCount = this.querySelector('.load-more-btn').dataset.itemCount * this.querySelector('.load-more-btn').dataset.currentPage;
    
                    this.progressWrapper.querySelector('.products_showing').innerHTML = loadedCount;
                    this.progressWrapper.querySelector('.load_more_progress_bar > div').style.width = ((loadedCount / this.totalProducts) * 100) + '%';
                }
                
                if (localStorage.getItem('collectionsLoadedPage') == currentPage && localStorage.getItem('collectionsLoadedUrl') == window.location.pathname) {
                    window.scrollTo(0, localStorage.getItem('collectionsSrollPosition'));
                }
            }
        });
    }

    onPreviousButtonClick() {
        let currentPage = parseInt(this.previousButton.dataset.currentPage) - 1;

        if (window.location.href.includes('sort_by') || window.location.href.includes('q=')) {
            history.pushState(null, null, '?page=' + currentPage + '&' + window.location.href.split('?')[1].replace(`page=${this.previousButton.dataset.currentPage}&`, ''));
        } else {
            history.pushState(null, null, '?page=' + currentPage);
        }

        this.loadPage(currentPage, true);
        // Update the attributes needed for the next click event
        if (this.previousButton) {
            this.previousButton.setAttribute("data-current-page", currentPage);
        }
    }

    onButtonClick() {
        let currentPage = parseInt(this.loadMoreButton.dataset.currentPage) + 1;

        if (window.location.href.includes('sort_by') || window.location.href.includes('q=')) {
            history.pushState(null, null, '?page=' + currentPage + '&' + window.location.href.split('?')[1].replace(`page=${this.loadMoreButton.dataset.currentPage}&`, ''));
        } else {
            history.pushState(null, null, '?page=' + currentPage);
        }

        this.loadPage(currentPage);
        // Update the attributes needed for the next click event
        if (this.previousButton) {
            this.previousButton.setAttribute("data-current-page", currentPage);
        }
        this.loadMoreButton.setAttribute("data-current-page", currentPage);
    }
}
customElements.define('paginate-load-more', PaginateLoadMore);